module.exports = __webpack_public_path__ + "img/volume_up_icon.a3626d6f.svg";